<template>
  <v-row no-gutters class="fill-height align-start justify-start">
    <v-col cols="12">
      <base-header title="Analytics" :menu="headerMenu" />
    </v-col>
    <v-col
      cols="12"
      style="width: 100%; height: calc(100% - 73px)"
      class="pa-0"
    >
      <div
        id="map"
        style="width: 100%; height: calc(100% - 73px); margin-top: 73px"
      ></div>
      <v-card
        class="users-card pa-3"
        width="410px"
        max-height="500px"
        style="margin-top: 73px"
        v-if="this.detailPopup.detailItems.length"
      >
        <v-col v-if="errors.fetchCluster">
          <span>{{ $t('message.pages.analytics.errorOnSearch') }}</span>
        </v-col>
        <v-col v-else-if="loadings.fetchCluster">
          <loading-logo :value="120" />
        </v-col>
        <v-col v-else>
          <v-row>
            <v-col>
              <v-col class="pa-0" v-if="detailPopup.cityRegion">
                <span
                  class="font-weight-medium primary--text text-body-1 font-weight-bold"
                  >{{ detailPopup.cityRegion }}</span
                >
              </v-col>
              <v-col class="pa-0" v-if="detailPopup.country">
                <span class="primary--text text-body-2">{{
                  detailPopup.country
                }}</span>
              </v-col>
              <v-col class="pa-0">
                <span class="text-caption text-body-2" style="color: #585d83">
                  {{ detailPopup.detailItems.length }}
                  {{ $t('message.pages.analytics.peopleWatching') }}
                </span>
              </v-col>
            </v-col>
            <v-btn icon @click="closeDetailModal">
              <v-icon small>mdi-close</v-icon>
            </v-btn>
          </v-row>
          <v-list flat dense style="overflow-y: auto; max-height: 400px">
            <v-list-item-group
              color="primary"
              v-model="selectedListIndex"
              @change="handleSelectUser"
              active-class=""
            >
              <template v-for="(item, i) in detailPopup.detailItems">
                <v-divider :key="'divider' + i"></v-divider>
                <v-list-item :key="'icon' + i" class="px-1">
                  <template v-slot:default>
                    <v-icon color="primary" small>mdi-account</v-icon>
                    <v-list-item-content class="pl-2">
                      <span class="text-body-2">
                        <!-- Usuário {{ item.user_id.substring(0, 8) }} -->
                        {{
                          `${item.ip} - ${item.browser_name} - ${item.os_name}`
                        }}
                      </span>
                    </v-list-item-content>
                    <v-list-item-icon>
                      <v-icon color="primary" small>mdi-chevron-right</v-icon>
                    </v-list-item-icon>
                  </template>
                </v-list-item>
              </template>
            </v-list-item-group>
          </v-list>
        </v-col>
      </v-card>
      <v-col class="total-users" cols="12">
        <v-row class="ma-0">
          <div style="width: 360px" class="ma-3">
            <v-card class="px-8 py-2 card-item">
              <span class="white--text text-h3">{{ this.totalUsers }}</span>
              <span
                class="white--text font-weight-light"
                style="z-index: 50000"
              >
                {{ $t('message.pages.analytics.peopleWatching') }}</span
              >
            </v-card>
          </div>
          <div style="width: 360px" class="ma-3">
            <v-card class="px-4 py-2 card-item">
              <v-col cols="12">
                <v-row class="ma-0">
                  <v-col class="text-center" cols="4">
                    <v-icon color="white">mdi-monitor</v-icon>
                    <br />
                    <span class="white--text font-weight-light text-body-2"
                      >Desktop</span
                    >
                    <br />
                    <span class="white--text text-h5 font-weight-bold">{{
                      this.devices.desktop
                    }}</span>
                    <br />
                    <span class="text-body-2" style="color: #c2c6e7">{{
                      this.devicePercent.desktop
                    }}</span>
                  </v-col>
                  <v-col class="text-center" cols="4">
                    <v-icon color="white">mdi-cellphone</v-icon>
                    <br />
                    <span class="white--text font-weight-light text-body-2"
                      >Mobile</span
                    >
                    <br />
                    <span class="white--text text-h5 font-weight-bold">{{
                      this.devices.mobile
                    }}</span>
                    <br />
                    <span class="text-body-2" style="color: #c2c6e7">{{
                      this.devicePercent.mobile
                    }}</span>
                  </v-col>
                  <v-col class="text-center" cols="4">
                    <v-icon color="white">mdi-screen-rotation</v-icon>
                    <br />
                    <span class="white--text font-weight-light text-body-2">
                      {{ $t('message.pages.analytics.other') }}</span
                    >
                    <br />
                    <span class="white--text text-h5 font-weight-bold">{{
                      this.devices.others
                    }}</span>
                    <br />
                    <span class="text-body-2" style="color: #c2c6e7">{{
                      this.devicePercent.others
                    }}</span>
                  </v-col>
                </v-row>
              </v-col>
            </v-card>
          </div>
          <v-col cols="4"> </v-col>
        </v-row>
      </v-col>

      <v-card
        v-if="!this.detailPopup.detailItems.length"
        class="time-range-input"
        style="margin-top: 73px"
      >
        <v-row class="ma-0 mx-6" align="center">
          <v-icon>mdi-clock</v-icon>
          <v-slider
            v-model="timeRangeIndex"
            class="mb-n5 pl-2"
            @change="getAndApplyData"
            max="8"
            min="0"
          ></v-slider>
          <span class="pl-2 text-body-2 text-center" style="width: 80px">{{
            timeRangeText
          }}</span>
        </v-row>
      </v-card>
      <v-dialog
        style="z-index: 9999; border-radius: 8px"
        v-model="detailPopup.dialogOpen"
        width="600px"
      >
        <v-card height="340px" v-if="errors.fetchUser">
          <v-toolbar elevation="0" dense>
            <v-spacer></v-spacer>
            <v-toolbar-items>
              <v-btn icon @click="detailPopup.dialogOpen = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar-items>
          </v-toolbar>
          <span class=" align-text mt-2 ml-4 d-block">
                  {{ $t('message.errors.internalServerError') }} -
                  {{ $t('message.errors.pleaseTryAgain') }}
                </span>
        </v-card>
        <v-card height="340px" v-else-if="loadings.fetchUser">
          <v-toolbar elevation="0" dense>
            <v-spacer></v-spacer>
            <v-toolbar-items>
              <v-btn icon @click="detailPopup.dialogOpen = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar-items>
          </v-toolbar>
          <loading-logo :value="160" />
        </v-card>
        <v-card v-else>
          <v-toolbar elevation="0">
            <v-toolbar-title
              class="primary--text font-weight-medium pt-1"
              style="font-size: 18px"
            >
              {{
                `${detailPopup.selectedUser.user.ip} - ${detailPopup.selectedUser.user.browser_name} - ${detailPopup.selectedUser.user.os_name}`
              }}
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
              <v-btn icon @click="detailPopup.dialogOpen = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar-items>
          </v-toolbar>
          <v-col cols="12" class="pt-0" style="font-size: 13px">
            <v-col cols="12" class="pt-0">
              <div class="preview-container">
                <v-row class="ma-0" align="center" justify="center">
                  <div
                    style="height: 225px; width: 400px; display: flex"
                    class="align-center justify-center"
                  >
                    <v-img
                      :src="detailPopup.selectedUser.video.thumbnail"
                    ></v-img>
                  </div>
                </v-row>
                <v-row class="ma-0 mt-4" align="center" justify="center">
                  <div class="wrapper-progress-container">
                    <div class="wrapper-progress"></div>
                    <div
                      class="progress-content"
                      :style="`width: ${detailPopup.selectedUser.video.progress}%`"
                    ></div>
                  </div>
                  <span class="pl-3">
                    {{
                      secondsToMinuteSeconds(
                        detailPopup.selectedUser.video.current_time
                      )
                    }}/{{
                      secondsToMinuteSeconds(
                        detailPopup.selectedUser.video.duration
                      )
                    }}</span
                  >
                </v-row>
              </div>
              <v-row justify="space-between" class="ma-0 my-2">
                <span class="font-weight-medium pt-2">Video</span>
                <v-btn
                  @click="handleSelectVideo(detailPopup.selectedUser.video)"
                  text
                  small
                >
                  {{ detailPopup.selectedUser.video.title }}
                </v-btn>
              </v-row>
              <v-divider></v-divider>
              <v-row justify="space-between" class="ma-0 my-2">
                <span class="font-weight-medium">{{
                  $t('message.pages.analytics.lastContact')
                }}</span>
                <span>{{ detailPopup.selectedUser.user.last_request }}</span>
              </v-row>
              <v-divider></v-divider>
              <v-row justify="space-between" class="ma-0 my-2">
                <span class="font-weight-medium">IP</span>
                <span>{{ detailPopup.selectedUser.user.ip }}</span>
              </v-row>
              <v-divider></v-divider>
              <v-row justify="space-between" class="ma-0 my-2">
                <span class="font-weight-medium">{{
                  $t('message.pages.analytics.browser')
                }}</span>
                <span
                  >{{ detailPopup.selectedUser.user.browser_name }} -
                  {{ detailPopup.selectedUser.user.browser_version }}</span
                >
              </v-row>
              <v-divider></v-divider>
              <v-row justify="space-between" class="ma-0 my-2">
                <span class="font-weight-medium">OS</span>
                <span
                  >{{ detailPopup.selectedUser.user.os_name }} -
                  {{ detailPopup.selectedUser.user.os_version }}</span
                >
              </v-row>
              <v-divider></v-divider>
              <v-row justify="space-between" class="ma-0 my-2">
                <span class="font-weight-medium">{{
                  $t('message.pages.analytics.device')
                }}</span>
                <span
                  >{{ detailPopup.selectedUser.user.device_type }} -
                  {{ detailPopup.selectedUser.user.device_model }}</span
                >
              </v-row>
              <v-divider></v-divider>
              <v-row justify="space-between" class="ma-0 my-2">
                <span class="font-weight-medium">{{
                  $t('message.pages.analytics.realtime.local')
                }}</span>
                <span>
                  {{ detailPopup.selectedUser.user.city }}/{{
                    detailPopup.selectedUser.user.region
                  }}
                  - {{ detailPopup.selectedUser.user.country }}
                </span>
              </v-row>
              <v-divider></v-divider>
              <v-row justify="space-between" class="ma-0 mt-2">
                <span class="font-weight-medium">{{
                  $t('message.pages.analytics.reference')
                }}</span>
                <span>{{ detailPopup.selectedUser.user.referrer }}</span>
              </v-row>
            </v-col>
          </v-col>
        </v-card>
      </v-dialog>
    </v-col>
  </v-row>
</template>

<script>
// external imports
import { format } from 'date-fns'
import L from 'leaflet'

// API
import analyticsApi from '@/services/newAnalyticsApi'

// Components
import LoadingLogo from '@/components/LoadingLogo.vue'

// CSS
import 'leaflet/dist/leaflet.css'

import i18n from '@/translations/lang'

export default {
  name: 'Realtime',
  components: {
    LoadingLogo,
    BaseHeader: () => import('@/components/BaseHeader.vue'),
  },
  data() {
    return {
      map: null,
      makingRequest: false,
      fetchUserTimeout: null,
      animationTimeout: null,
      animationProgressbarRealTime: null,
      selectedListIndex: null,
      lastSelectedListIndex: null,
      timeRanges: [
        {
          text: `24 ${i18n.t('message.pages.analytics.realtime.hours')}`,
          seconds: 3600 * 24,
        },
        {
          text: `12 ${i18n.t('message.pages.analytics.realtime.hours')}`,
          seconds: 3600 * 12,
        },
        {
          text: `6 ${i18n.t('message.pages.analytics.realtime.hours')}`,
          seconds: 3600 * 6,
        },
        {
          text: `3 ${i18n.t('message.pages.analytics.realtime.hours')}`,
          seconds: 3600 * 3,
        },
        {
          text: `1 ${i18n.t('message.pages.analytics.realtime.hour')}`,
          seconds: 3600,
        },
        {
          text: `30 ${i18n.t('message.pages.analytics.realtime.minutes')}`,
          seconds: 1800,
        },
        {
          text: `10 ${i18n.t('message.pages.analytics.realtime.minutes')}`,
          seconds: 600,
        },
        {
          text: `5 ${i18n.t('message.pages.analytics.realtime.minutes')}`,
          seconds: 300,
        },
        {
          text: `${i18n.t('message.pages.analytics.realtime.now')}`,
          seconds: 60,
        },
      ],
      texts: [],
      geojson: null,
      totalUsers: 0,
      loadings: {
        fetchCluster: false,
        fetchUser: false,
      },
      devices: {
        desktop: 0,
        mobile: 0,
        tablet: 0,
      },
      errors: {
        fetchCluster: null,
        fetchUser: null,
      },
      devicePercent: {
        desktop: '0%',
        mobile: '0%',
        others: '0%',
      },
      timeRangeIndex: 8,
      detailPopup: {
        detailItems: [],
        country: null,
        cityRegion: null,
        selectedUser: {
          requests: [],
          user: {},
          video: {},
        },
        dialogOpen: false,
      },
      updateTimeout: null,
    }
  },
  computed: {
    timeRangeText() {
      return this.timeRanges[this.timeRangeIndex].text
    },
    headerMenu() {
      return [
        {
          title: i18n.t('message.pages.analytics.history'),
          to: { name: 'AnalyticsV2Account' },
        },
        {
          title: i18n.t('message.routesTitles.AnalyticsV2Realtime'),
          to: { name: 'AnalyticsV2Realtime' },
        },
      ]
    },
  },
  async mounted() {
    this.map = L.map('map').setView([0, 0], 3)
    const southWest = L.latLng(-89.98155760646617, -180)
    const northEast = L.latLng(89.99346179538875, 180)
    const bounds = L.latLngBounds(southWest, northEast)
    this.map.options.minZoom = 3
    this.map.setMaxBounds(bounds)

    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      maxZoom: 19,
      attribution:
        '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>',
    }).addTo(this.map)

    await this.getAndApplyData()
    this.map.on('zoomend', this.getAndApplyData)
    this.map.on('moveend', this.getAndApplyData)

    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState == 'visible') {
        this.getAndApplyData()
        clearInterval(this.updateTimeout)
        this.updateTimeout = setInterval(this.getAndApplyData, 10000)
      } else {
        clearInterval(this.updateTimeout)
      }
    })
  },
  beforeDestroy() {
    clearInterval(this.updateTimeout)
    this.updateTimeout = null
  },
  methods: {
    handleSelectVideo(video) {
      this.$router.push({
        name: 'VideoPage',
        params: { id: video.id },
      })
    },
    async getAndApplyData() {
      if (
        document.visibilityState != 'visible' ||
        this.makingRequest ||
        this.$route.name != 'AnalyticsV2Realtime'
      ) {
        return
      }
      this.makingRequest = true
      try {
        const { data } = await analyticsApi.getRealtime(
          this.map.getBounds().toBBoxString(),
          this.map.getZoom(),
          this.timeRanges[this.timeRangeIndex].seconds
        )
        if (this.geojson) {
          this.geojson.remove()
        }
        this.texts.forEach((text) => {
          text.remove()
        })
        this.texts = []
        this.totalUsers = data.total_users

        this.devices = data.devices
        if (this.totalUsers !== 0) {
          this.devicePercent = {
            desktop: `${(
              (this.devices.desktop / data?.total_users) *
              100
            ).toFixed(0)}%`,
            mobile: `${((this.devices.mobile / data.total_users) * 100).toFixed(
              0
            )}%`,
            others: `${((this.devices.others / data.total_users) * 100).toFixed(
              0
            )}%`,
          }
        } else {
          this.devicePercent = {
            desktop: '0%',
            mobile: '0%',
            others: '0%',
          }
        }
        const _this = this
        this.geojson = L.geoJson(data.geojson, {
          pointToLayer(feature, latlng) {
            if (isNaN(latlng.lat) || isNaN(latlng.lng)) return
            const pointsSize = feature.properties.point_count || 1
            const marker = L.marker(latlng, {
              icon: L.divIcon({
                iconSize: 'auto',
                html: `<div class="panda-realtime-marker"><div class="panda-map-realtime-circle-ripple-1 panda-map-realtime-circle-ripple"></div><div class="panda-map-realtime-circle-ripple-2 panda-map-realtime-circle-ripple"></div><div class="panda-map-realtime-marker-text">${pointsSize}</div></div>`,
              }),
            })
            marker.on('click', () => {
              _this.onSelectMarker(feature.properties)
            })

            return marker
          },
        }).addTo(this.map)
      } catch (error) {
        console.log(error)
      }
      this.makingRequest = false
    },
    closeDetailModal() {
      this.detailPopup.detailItems = []
      this.detailPopup.country = null
      this.detailPopup.cityRegion = null
    },
    async onSelectMarker(props) {
      if (props.cluster) {
        try {
          this.loadings.fetchCluster = true
          const { data } = await analyticsApi.getRealtime(
            this.map.getBounds().toBBoxString(),
            this.map.getZoom(),
            this.timeRanges[this.timeRangeIndex].seconds,
            props.cluster_id
          )
          this.loadings.fetchCluster = false
          this.detailPopup.detailItems = data.map((item) => ({
            ...item.properties,
            user_id: `${item.properties.user_id}`,
          }))
          const firstItem = data[0].properties
          const isSameRegion = this.detailPopup.detailItems.every(
            (item) => item.region === firstItem.region
          )
          const isSameCountry = this.detailPopup.detailItems.every(
            (item) => item.country === firstItem.country
          )
          const isSameCity = this.detailPopup.detailItems.every(
            (item) => item.city === firstItem.city
          )
          if (isSameCountry) {
            this.detailPopup.country = firstItem.country
          } else {
            this.detailPopup.country = null
          }
          if (isSameRegion && isSameCity) {
            this.detailPopup.cityRegion = `${firstItem.city}/${firstItem.region}`
          } else if (isSameRegion) {
            this.detailPopup.cityRegion = `${firstItem.region}`
          } else {
            this.detailPopup.cityRegion = null
          }
          this.errors.fetchCluster = false
        } catch (error) {
          this.loadings.fetchCluster = false
          this.errors.fetchCluster = true
          console.log(error)
        }
      } else {
        this.detailPopup.detailItems = [
          {
            ...props,
            user_id: `${props.user_id}`,
          },
        ]
        this.detailPopup.country = props.country
        this.detailPopup.cityRegion = `${props.city}/${props.region}`
      }
    },

    async fetchUser() {
      const selected = this.detailPopup.detailItems[this.selectedListIndex]
      const { data } = await analyticsApi.getRealtimeUser(
        selected.user_id,
        selected.video_external_id
      )
      this.detailPopup.selectedUser = data

    },

    async userDataDialog() {
      const selected = this.detailPopup.detailItems[this.selectedListIndex]

      const last_request =
        this.detailPopup.selectedUser.requests[
          this.detailPopup.selectedUser.requests.length - 1
        ]
      const lastRequestDate = new Date(last_request.ts)

      if (this.animationProgressbarRealTime === null) {
        this.animationProgressbarRealTime = last_request.current_time
      } else if (
        this.animationProgressbarRealTime !== 0 &&
        this.animationProgressbarRealTime < last_request.current_time + 60
      ) {
        this.animationProgressbarRealTime++
      }
      if (
        !last_request.current_time ||
        this.detailPopup.selectedUser.video.current_time >=
          this.detailPopup.selectedUser.video.duration
      ) {
        this.animationProgressbarRealTime =
          this.detailPopup.selectedUser.video.duration
      } else {
        this.detailPopup.selectedUser.video.progress =
          (this.animationProgressbarRealTime * 100) /
          this.detailPopup.selectedUser.video.duration
        this.detailPopup.selectedUser.video.current_time =
          this.animationProgressbarRealTime || 0
      }
      this.detailPopup = { ...this.detailPopup }
      this.detailPopup.selectedUser.user_id = selected.user_id
      this.detailPopup.selectedUser.user.last_request = format(
        lastRequestDate,
        'dd/MM/yyyy HH:mm:ss'
      )

      !this.detailPopup.dialogOpen
        ? (this.animationProgressbarRealTime = null)
        : this.animationProgressbarRealTime

      this.loadings.fetchUser = false
    },
    secondsToMinuteSeconds(seconds) {
      const minutes = Math.floor(seconds / 60)
      const secondsLeft = seconds % 60
      return `${minutes}:${secondsLeft < 10 ? '0' : ''}${secondsLeft}`
    },
    async handleSelectUser() {
      clearTimeout(this.fetchUserTimeout)
      clearTimeout(this.animationTimeout)
      this.detailPopup.dialogOpen = true
      if (this.selectedListIndex === undefined) {
        this.selectedListIndex = this.lastSelectedListIndex
      }
      this.lastSelectedListIndex = this.selectedListIndex
      this.loadings.fetchUser = true
      try {
        await this.fetchUser()
        await this.userDataDialog()
        this.errors.fetchUser = false
      } catch (error) {
        console.log(error)
        this.errors.fetchUser = true

      }
      this.loadings.fetchUser = false
      const _this = this

      this.animationTimeout = setTimeout(async () => {
        animationUserRealtime()
      }, 1000)
      this.fetchUserTimeout = setTimeout(async () => {
        fetchUserRealtime()
      }, 15 * 1000)

      async function fetchUserRealtime() {
        await _this.fetchUser()
        clearTimeout(_this.animationTimeout)
        await _this.userDataDialog()
        setTimeout(fetchUserRealtime, 15 * 1000)
      }
      async function animationUserRealtime() {
        await _this.userDataDialog()
        if (_this.detailPopup.dialogOpen) {
          setTimeout(animationUserRealtime, 1000)
        }
      }
    },
  },
}
</script>

<style scoped>
.wrapper-progress {
  width: 100%;
  height: 10px;
  background: #f5f5f5;
  border-radius: 15px;
}
.preview-container {
  border: 1px solid #e6e8f8;
  padding: 15px;
}
.video-chart-container {
  position: absolute;
  width: 100%;
  top: 20px;
  padding-left: 60px;
  padding-right: 50px;
}
.wrapper-progress-container {
  width: 315px;
  height: calc(100% - 73px);
  position: relative;
  top: 0;
  left: 0;
}
.progress-content {
  height: 10px;
  background: var(--v-primary-base);
  transition: width 0.5s ease;
  border-radius: 15px;
  position: absolute;
  top: 0;
  left: 0;
}
.time-range-input {
  border-radius: 30px;
  z-index: 9999;
  width: 363px;
  height: 52px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: absolute;
  top: 30px;
  left: 50%;
  transform: translateX(-50%);
}
.users-card {
  position: absolute;
  top: 30px;
  right: 30px;
  border-radius: 8px;
  z-index: 1000;
}
#map {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}
.total-users {
  position: absolute;
  bottom: 0;
  left: 0;
  z-index: 1000;
}
.card-item {
  background: #232536;
  width: 100%;
  height: 132px;
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  border-radius: 8px;
  justify-content: center;
}

.card-item-background-shape {
  position: absolute;
  top: 0;
  left: 0;
  margin-top: auto;
  width: 100%;
  height: calc(100% - 73px);
  display: flex;
  border-radius: 10px;
}
.card-item-background-shape svg {
  position: absolute;
  bottom: 0;
  left: 0;
  margin: auto;
  border-radius: 10px;
}
</style>
<style>
.panda-realtime-marker {
  transform: translate(-50%, -50%);
  box-shadow: 0 0 0 0 transparent;

  border-radius: 50%;
  background-color: var(--v-primary-base);
  width: 35px;
  height: 35px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 100%;
  opacity: 0.85;
}
.panda-map-realtime-marker-text {
  position: absolute;
  color: #fff;
  font-weight: bold;
  font-size: 0.9rem;
}
@keyframes ripple-animation {
  0% {
    transform: scale(0.7);
    opacity: 1;
  }
  100% {
    transform: scale(1.8);
    opacity: 0;
  }
}
.panda-map-realtime-circle-ripple {
  width: 35px;
  height: 35px;
  border-radius: 100%;
  position: absolute;
  background: var(--v-primary-base);
  animation: ripple-animation 2s infinite ease-out;
}
.panda-map-realtime-circle-ripple-1 {
  animation-delay: 0s;
}
.panda-map-realtime-circle-ripple-2 {
  animation-delay: 700ms;
}
.leaflet-marker-icon {
  border: 0;
  background-color: transparent;
}
.leaflet-pane .leaflet-overlay-pane {
  margin-top: -50000px;
  margin-left: -50000px;
  width: calc(100000px + 100%);
  height: calc(100000px + 100%);
  background-color: rgba(0, 112, 206, 0.35);
}
</style>
